/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { Location } from "@reach/router"

function SEO({ description, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const siteTitle = site.siteMetadata.title
  const metaDescription = description || site.siteMetadata.description
  const siteUrl = site.siteMetadata.siteUrl

  const todaysDate = new Date()

  return (
    <Location>
      {({ location }) => (
        <Helmet
          htmlAttributes={{
            lang: "en-GB",
          }}
          title={title}
          titleTemplate={`%s - ${siteTitle}`}
          meta={[
            {
              name: `description`,
              content: metaDescription,
            },
            {
              name: `dcterms.Identifier`,
              content: siteUrl,
            },
            {
              name: `dcterms.Format`,
              content: `text/html`,
            },
            {
              name: `dcterms.Relation`,
              content: siteTitle,
            },
            {
              name: `dcterms.Language`,
              content: `en_gb`,
            },
            {
              name: `dcterms.Publisher`,
              content: siteTitle,
            },
            {
              name: `dcterms.Type`,
              content: `text/html`,
            },
            {
              name: `dcterms.Coverage`,
              content: siteUrl,
            },
            {
              name: `dcterms.Rights`,
              content: `&copy; We Make Stuff Ltd. All rights reserved.`,
            },
            {
              name: `dcterms.Title`,
              content: `${title} - ${site.siteMetadata.title}`,
            },
            {
              name: `dcterms.Date`,
              content: todaysDate.toISOString().slice(0, 10),
            },
            {
              name: `dcterms.Description`,
              content: metaDescription,
            },
            {
              name: `dcterms.Creator`,
              content: siteTitle,
            },
            {
              name: `dcterms.Contributor`,
              content: siteTitle,
            },
            {
              name: `og:type`,
              content: `website`,
            },
            {
              name: `og:locale`,
              content: `en_gb`,
            },
            {
              name: `og:url`,
              content: `${siteUrl}${location.pathname}`,
            },
            {
              name: `og:title`,
              content: `${title} - ${site.siteMetadata.title}`,
            },
            {
              name: `og:description`,
              content: metaDescription,
            },
            {
              name: `og:image`,
              content: `${image}?fm=jpg&fit=crop&w=1776&h=1184`,
            },
            {
              name: `og:image:type`,
              content: `image/jpeg`,
            },
            {
              name: `og:image:width`,
              content: `1776`,
            },
            {
              name: `og:image:height`,
              content: `1184`,
            },
            {
              name: `og:site_name`,
              content: siteTitle,
            },
            {
              name: `og:see_also`,
              content: `https://twitter.com/madebymutual`,
            },
            {
              name: `twitter:card`,
              content: `summary_large_image`,
            },
            {
              name: `twitter:site`,
              content: `@madebymutual`,
            },
            {
              name: `twitter:title`,
              content: `${title} - ${site.siteMetadata.title}`,
            },
            {
              name: `twitter:description`,
              content: metaDescription,
            },
            {
              name: `twitter:image`,
              content: `${image}?fm=jpg&fit=crop&w=1200&h=675`,
            },
          ]}
        >
          <script type="application/ld+json">
            {`
              {"@context":"http://schema.org","@type":"WebSite","name":"Mutual","description":"The official website for Mutual","url":"https://madebymutual.com/","image":"https://madebymutual.com/assets/uploads/images/ouFkQOXc_400x400.jpg","sameAs":["http://twitter.com/madebymutual"],"copyrightHolder":{"@type":"Corporation","name":"Mutual","url":"https://madebymutual.com/","sameAs":["http://twitter.com/madebymutual"],"telephone":"01424 559 858","email":"hello@madebymutual.com","address":{"@type":"PostalAddress","streetAddress":"45 Robertson Street","addressLocality":"Hastings","addressRegion":"East Sussex","postalCode":"TN34 1HL","addressCountry":"United Kingdom"},"location":{"@type":"Place","name":"Mutual","hasMap":"http://maps.google.com/maps?q=Mutual%2C+45+Robertson+Street%2C+Hastings%2C+East+Sussex%2C+TN34+1HL%2C+United+Kingdom","telephone":"01424 559 858","url":"https://madebymutual.com/","sameAs":["http://twitter.com/madebymutual"],"geo":{"@type":"GeoCoordinates","latitude":"50.855214","longitude":"0.577972"},"address":{"@type":"PostalAddress","streetAddress":"45 Robertson Street","addressLocality":"Hastings","addressRegion":"East Sussex","postalCode":"TN34 1HL","addressCountry":"United Kingdom"}}},"author":{"@type":"Corporation","name":"Mutual","url":"https://madebymutual.com/","sameAs":["http://twitter.com/madebymutual"],"telephone":"01424 559 858","email":"hello@madebymutual.com","address":{"@type":"PostalAddress","streetAddress":"45 Robertson Street","addressLocality":"Hastings","addressRegion":"East Sussex","postalCode":"TN34 1HL","addressCountry":"United Kingdom"},"location":{"@type":"Place","name":"Mutual","hasMap":"http://maps.google.com/maps?q=Mutual%2C+45+Robertson+Street%2C+Hastings%2C+East+Sussex%2C+TN34+1HL%2C+United+Kingdom","telephone":"01424 559 858","url":"https://madebymutual.com/","sameAs":["http://twitter.com/madebymutual","http://instagram.com/madebymutual"],"geo":{"@type":"GeoCoordinates","latitude":"50.855214","longitude":"0.577972"},"address":{"@type":"PostalAddress","streetAddress":"45 Robertson Street","addressLocality":"Hastings","addressRegion":"East Sussex","postalCode":"TN34 1HL","addressCountry":"United Kingdom"}}}}  
            `}
          </script>
        </Helmet>
      )}
    </Location>
  )
}

SEO.defaultProps = {
  description: ``,
  image: `https://images.mutualcdn.com/mutual/images/card-sorting.jpg`,
}

SEO.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default SEO
